import BaseReducer from "./BaseReducer";

class OfficerReducer extends BaseReducer {
  domain = "Officer";
  type = "View";

  initialState = {
    // Loading flag for the Select component
    loadingOfficers: false,
    loadingPoliceId: false,
    policeId: 1,
    // The options for the Search Officer dropdown list fetch from backend API
    officersOptions: [],
    // The officer input that is populated in the Search Officer search box
    searchedOfficer: null,
    // The officer that is selected for form submission
    officer: null,
  };
}

const reducer = new OfficerReducer();

export default reducer;
